import React from 'react';
import { CookiesProvider as OriginalCookiesProvider } from 'react-cookie';
import { getCookies } from '../../utils/cookie';

const CookieProvider = ({ children }) => <OriginalCookiesProvider cookies={getCookies()}>{children}</OriginalCookiesProvider>;

export default CookieProvider;
